import { useTask, utils as gleamerUtils } from '@gleamer/ui';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import {
  activeDetectionAtom,
  displayPredictionsAtom,
  displayedPredictionsAtom,
  displayedPredictionsBySeriesAtom,
  studiesInstanceOrder,
  incrementActiveDetectionIndexAtom,
  initalPredictionsAtom,
  onlyWithouStatusDetectionsAtom,
  getOrCreateCurrentPredictionStorageAtom,
  currentPredictionKeyAtom,
  predictionsConfidencesAtom,
  setDetectionStatusAtom,
  setPredictionsAtom,
  toogleDisplayPredictionsAtom,
  resetPredictionsAtom,
  reviewProgressAtom,
} from './predictions.atoms';

export function useAllPredictions() {
  return useAtomValue(useAtomValue(getOrCreateCurrentPredictionStorageAtom));
}

export function useInitalPredictions() {
  return useAtomValue(initalPredictionsAtom);
}

export function useDisplayedPredictions() {
  return useAtomValue(displayedPredictionsAtom);
}

export function useSetCurrentPredictionsKey() {
  return useSetAtom(currentPredictionKeyAtom);
}

export function useSetPredictions() {
  return useSetAtom(setPredictionsAtom);
}

/**
 * The task the predictions belong to. None in the bac mode: a task opened
 * earlier in the same tab stays in the store, but it does not apply there.
 */
export function usePredictionsTask() {
  const task = useTask();
  return gleamerUtils.getMode() === gleamerUtils.BAC_MODE_NAME ? null : task;
}

export function useDisplayPredictions() {
  return useAtom(displayPredictionsAtom);
}

export function useSetStudiesOrder() {
  return useSetAtom(studiesInstanceOrder);
}

export function useDisplayedPredictionsBySeries() {
  return useAtomValue(displayedPredictionsBySeriesAtom);
}

export function useShouldDisplayPredictions() {
  return useAtomValue(displayPredictionsAtom);
}

export function useToggleDisplayPredictions() {
  return useSetAtom(toogleDisplayPredictionsAtom);
}

export function useCurrentDetectionId() {
  return useAtom(activeDetectionAtom);
}

export function useSetDetectionStatus() {
  return useSetAtom(setDetectionStatusAtom);
}

export function useSetNextDetectionId() {
  return useSetAtom(incrementActiveDetectionIndexAtom);
}

export function usePredictionsConfidences() {
  return useAtom(predictionsConfidencesAtom);
}

export function useSetPredictionsConfidences() {
  return useSetAtom(predictionsConfidencesAtom);
}

export function useOnlyWithoutStatusDetections() {
  return useAtom(onlyWithouStatusDetectionsAtom);
}

export function useResetPredictions() {
  return useSetAtom(resetPredictionsAtom);
}

export function useReviewProgress() {
  return useAtomValue(reviewProgressAtom);
}
